import React from 'react';

// Material Symbols Outlined wird normalerweise erst nach Cookie-Consent geladen
// (CookieConsent.tsx::loadGoogleFonts). Die Notfall-Seiten laden die Font hier
// zusätzlich idempotent — sie müssen auch ohne Consent mit Icons funktionieren
// (funktionale Notwendigkeit, kein Tracking).
export function ensureMaterialSymbols(): void {
  if (typeof document === 'undefined') return;
  if (document.getElementById('material-symbols-outlined-link')) return;
  const link = document.createElement('link');
  link.id = 'material-symbols-outlined-link';
  link.rel = 'stylesheet';
  link.href =
    'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0&display=swap';
  document.head.appendChild(link);
}

interface MIconProps {
  name: string;
  className?: string;
  style?: React.CSSProperties;
  filled?: boolean;
}

export const MIcon: React.FC<MIconProps> = ({ name, className = '', style, filled }) => (
  <span
    aria-hidden="true"
    className={`material-symbols-outlined ${className}`}
    style={filled ? { fontVariationSettings: "'FILL' 1", ...style } : style}
  >
    {name}
  </span>
);

export default MIcon;
